// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueGoodTable from 'vue-good-table'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueGoodTable)
Vue.use(BootstrapVue)
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.$seasonParam = 'Season'
Vue.prototype.$seasonTypeParam = 'SeasonType'
Vue.prototype.$teamIdParam = 'TeamId'
Vue.prototype.$lineupIdParam = 'LineupId'
Vue.prototype.$entityIdParam = 'EntityId'
Vue.prototype.$entityTypeParam = 'EntityType'
Vue.prototype.$typeParam = 'Type'
Vue.prototype.$statParam = 'Stat'
Vue.prototype.$startTypeParam = 'StartType'
Vue.prototype.$playerIdParam = 'PlayerId'
Vue.prototype.$startTypeParam = 'StartType'
Vue.prototype.$offDefParam = 'OffDef'
Vue.prototype.$opponentParam = 'Opponent'
Vue.prototype.$fromDateParam = 'FromDate'
Vue.prototype.$toDateParam = 'ToDate'
Vue.prototype.$fromMarginParam = 'FromMargin'
Vue.prototype.$toMarginParam = 'ToMargin'
Vue.prototype.$fromTimeParam = 'FromTime'
Vue.prototype.$toTimeParam = 'ToTime'
Vue.prototype.$periodParam = 'Period'
Vue.prototype.$xAxisParam = 'Xaxis'
Vue.prototype.$yAxisParam = 'Yaxis'
Vue.prototype.$xAxisTypeParam = 'XaxisType'
Vue.prototype.$yAxisTypeParam = 'YaxisType'
Vue.prototype.$groupByParam = 'GroupBy'
Vue.prototype.$gameIdParam = 'GameId'
Vue.prototype.$starterStateParam = 'StarterState'
Vue.prototype.$possessionTypeParam = 'PossessionType'
Vue.prototype.$timeTypeParam = 'TimeType'
Vue.prototype.$periodLteParam = 'PeriodLte'
Vue.prototype.$periodGteParam = 'PeriodGte'
Vue.prototype.$periodEqualsParam = 'PeriodEquals'
Vue.prototype.$shotTimeLteParam = 'ShotTimeLte'
Vue.prototype.$shotTimeGteParam = 'ShotTimeGte'
Vue.prototype.$shotDistanceLteParam = 'ShotDistanceLte'
Vue.prototype.$shotDistanceGteParam = 'ShotDistanceGte'
Vue.prototype.$secondsSincePossessionStartLteParam = 'SecondsSincePossessionStartLte'
Vue.prototype.$secondsSincePossessionStartGteParam = 'SecondsSincePossessionStartGte'
Vue.prototype.$secondsSinceOrebGteParam = 'SecondsSinceOrebGte'
Vue.prototype.$secondsSinceOrebLteParam = 'SecondsSinceOrebLte'
Vue.prototype.$offOwnOrebParam = 'OffOwnOreb'
Vue.prototype.$offOwnDrebParam = 'OffOwnDreb'
Vue.prototype.$offOwnMissParam = 'OffOwnMiss'
Vue.prototype.$orebShotTypeParam = 'OrebShotType'
Vue.prototype.$possessionLengthGte = 'PossessionLengthGte'
Vue.prototype.$possessionLengthLte = 'PossessionLengthLte'
Vue.prototype.$assistedParam = 'Assisted'
Vue.prototype.$blockedParam = 'Blocked'
Vue.prototype.$assistPlayerIdParam = 'AssistPlayerId'
Vue.prototype.$blockPlayerIdParam = 'BlockPlayerId'
Vue.prototype.$shotValueParam = 'ShotValue'
Vue.prototype.$shotTypeParam = 'ShotType'
Vue.prototype.$subUnitSizeParam = 'SubUnitSize'
Vue.prototype.$leverageParam = 'Leverage'

// api endpoints
Vue.prototype.$getTeamsEndPoint = 'get-teams/'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js